import * as React from "react";
import { ModalContainer } from "../../../../containers/modules/MiniCart/containers/ModalContainer.js";
const MiniCartModal = (props) => {
  return /* @__PURE__ */ React.createElement(ModalContainer, { ...props });
};
export {
  MiniCartModal
};
//# sourceMappingURL=MiniCartModal.js.map
